export { default } from './ResultsDetailsPopup';
